module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_11-fde8b07ca83180dc60797f81d140317c.jpg";